
import React from 'react';
export default function Blog009() {
  return (
    <section>
    <article>
      <h2>9. 08-19-2022</h2>
      <h3>Rock Paper Scissors</h3>
      <p> 
        Hello, <br /><br />
        I went ahead and started the 'Learn Javascript by Building 7 Games - Full Course' by Ania Kubów on the freecodecamp.org 
        Youtube channel. I mentioned I was thinking about doing this or going back through the Web Dev Simplified 'snake' tutorial. 
        I am starting with the first game in the video, with the goal of completing them all in order. 
        <br />
        With that said, I have it in my schedule to take it a bit easy for the next few days. I may want to revisit the game tutorials 
        I have already built to refresh and gain a further grasp on the functions syntax. 
        <br /><br />
        For this blog I would like to write about the code project from yesterday, following the tutorial By Ania. This tutorial gave
        me a deeper look and understanding of button onclick functions. I would like to learn more about Math, Math.floor, and Math.random().
        I see what they are able to do, but I would like to learn and understand, how and why. Building projects is an easy and engaging 
        way to create a learning criteria. I build a project and take note of the bits I did not understand, or could use a better understanding
        there-of. With this list I look up each bit on Google and/or find tutorials on the subject. I am using this method originally on my
        own text-based game I am creating. Now I am diving into the tutorials to learn what I need for my own game, I am going to start 
        looking through documentation and additional tutorials to understand and learn about the tutorials I am watching to create my own game.
        It's confusing? A bit. It's a tutorial inside of a tutorial. Like 'Inception', but with tutorials. <br /><br />
        I do believe I mentioned in the last blog that I plan on recording some live coding videos, and recording the vlog a bit less often.
         I will probably still do the weekly vlog for the next few weeks. I would like to starting recording some morning coding. 
         I will probably go over the same three tutorials and then get to focusing on my own projects toward the end of the week. 
         I don't want to get lost in 'tutorial hell', but I also want to know enough that I can create functions with DOM manipulation, 
         create Math statements, and loops. With a set of tools I will get building. 

  


      </p> 
    </article>
   
    <h4>Links</h4>
    <br />
    <ul>

      <li>
        <a
          href="https://ericpolley.github.io/rockpaperscissors/"
          title="rockPaperScissors"
          rel="noopener noreferrer" 
          target="_blank"
        >
          <strong><p>Rock Paper Scissors</p></strong></a
        >
      </li>

      <li>
        <a
          href="https://www.youtube.com/watch?v=hHKFmBqIjoU&list=PLce5_YZyrUw7dNEL7F1T4kxAp0mMuattO"
          title="Vlog"
          rel="noopener noreferrer" 
          target="_blank"
        >
          <strong><p>THE VLOG - Video Blog Series</p></strong></a
        >
      </li>
      
      <li>
        <a
          href="http://erpolley.com"
          title="Check out my website"
          rel="noopener noreferrer" 
          target="_blank"
        >
          <strong><p>Check out my website</p></strong></a
        >
      </li>
    </ul>
  </section>
  )
}
